'use client';

import { useEffect } from 'react';
import { captureError } from '@focal-point/error-tracking/client';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    captureError(error, {
      tags: { type: 'global-error' },
      extra: { digest: error.digest },
    });
  }, [error]);

  return (
    <html lang="en">
      <body style={{
        background: '#F5F3EE',
        color: '#1B2432',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '24px',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      }}>
        <div style={{ textAlign: 'center', maxWidth: '600px' }}>
          <h1 style={{ fontSize: '48px', marginBottom: '16px' }}>
            Critical Error
          </h1>
          <p style={{ fontSize: '20px', marginBottom: '32px', color: '#4B505A' }}>
            A critical error occurred. We&apos;ve been notified.
          </p>
          <button
            onClick={reset}
            style={{
              background: '#234B7A',
              color: '#F7F5F0',
              padding: '12px 24px',
              borderRadius: '8px',
              border: 'none',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
            }}
          >
            Try Again
          </button>
        </div>
      </body>
    </html>
  );
}
